"use strict";
var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// node_modules/goober/dist/goober.cjs
var require_goober = __commonJS({
  "node_modules/goober/dist/goober.cjs"(exports2) {
    var e = { data: "" };
    var t = (t2) => "object" == typeof window ? ((t2 ? t2.querySelector("#_goober") : window._goober) || Object.assign((t2 || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : t2 || e;
    var r = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g;
    var l = /\/\*[^]*?\*\/|  +/g;
    var a = /\n+/g;
    var s = (e2, t2) => {
      let r2 = "", l2 = "", a2 = "";
      for (let n2 in e2) {
        let o2 = e2[n2];
        "@" == n2[0] ? "i" == n2[1] ? r2 = n2 + " " + o2 + ";" : l2 += "f" == n2[1] ? s(o2, n2) : n2 + "{" + s(o2, "k" == n2[1] ? "" : t2) + "}" : "object" == typeof o2 ? l2 += s(o2, t2 ? t2.replace(/([^,])+/g, (e3) => n2.replace(/(^:.*)|([^,])+/g, (t3) => /&/.test(t3) ? t3.replace(/&/g, e3) : e3 ? e3 + " " + t3 : t3)) : n2) : null != o2 && (n2 = /^--/.test(n2) ? n2 : n2.replace(/[A-Z]/g, "-$&").toLowerCase(), a2 += s.p ? s.p(n2, o2) : n2 + ":" + o2 + ";");
      }
      return r2 + (t2 && a2 ? t2 + "{" + a2 + "}" : a2) + l2;
    };
    var n = {};
    var o = (e2) => {
      if ("object" == typeof e2) {
        let t2 = "";
        for (let r2 in e2)
          t2 += r2 + o(e2[r2]);
        return t2;
      }
      return e2;
    };
    var c = (e2, t2, c2, p2, i2) => {
      let u2 = o(e2), d2 = n[u2] || (n[u2] = ((e3) => {
        let t3 = 0, r2 = 11;
        for (; t3 < e3.length; )
          r2 = 101 * r2 + e3.charCodeAt(t3++) >>> 0;
        return "go" + r2;
      })(u2));
      if (!n[d2]) {
        let t3 = u2 !== e2 ? e2 : ((e3) => {
          let t4, s2, n2 = [{}];
          for (; t4 = r.exec(e3.replace(l, "")); )
            t4[4] ? n2.shift() : t4[3] ? (s2 = t4[3].replace(a, " ").trim(), n2.unshift(n2[0][s2] = n2[0][s2] || {})) : n2[0][t4[1]] = t4[2].replace(a, " ").trim();
          return n2[0];
        })(e2);
        n[d2] = s(i2 ? { ["@keyframes " + d2]: t3 } : t3, c2 ? "" : "." + d2);
      }
      let f2 = c2 && n.g ? n.g : null;
      return c2 && (n.g = n[d2]), ((e3, t3, r2, l2) => {
        l2 ? t3.data = t3.data.replace(l2, e3) : -1 === t3.data.indexOf(e3) && (t3.data = r2 ? e3 + t3.data : t3.data + e3);
      })(n[d2], t2, p2, f2), d2;
    };
    var p = (e2, t2, r2) => e2.reduce((e3, l2, a2) => {
      let n2 = t2[a2];
      if (n2 && n2.call) {
        let e4 = n2(r2), t3 = e4 && e4.props && e4.props.className || /^go/.test(e4) && e4;
        n2 = t3 ? "." + t3 : e4 && "object" == typeof e4 ? e4.props ? "" : s(e4, "") : false === e4 ? "" : e4;
      }
      return e3 + l2 + (null == n2 ? "" : n2);
    }, "");
    function i(e2) {
      let r2 = this || {}, l2 = e2.call ? e2(r2.p) : e2;
      return c(l2.unshift ? l2.raw ? p(l2, [].slice.call(arguments, 1), r2.p) : l2.reduce((e3, t2) => Object.assign(e3, t2 && t2.call ? t2(r2.p) : t2), {}) : l2, t(r2.target), r2.g, r2.o, r2.k);
    }
    var u;
    var d;
    var f;
    var g = i.bind({ g: 1 });
    var b = i.bind({ k: 1 });
    exports2.css = i, exports2.extractCss = (e2) => {
      let r2 = t(e2), l2 = r2.data;
      return r2.data = "", l2;
    }, exports2.glob = g, exports2.keyframes = b, exports2.setup = function(e2, t2, r2, l2) {
      s.p = t2, u = e2, d = r2, f = l2;
    }, exports2.styled = function(e2, t2) {
      let r2 = this || {};
      return function() {
        let l2 = arguments;
        function a2(s2, n2) {
          let o2 = Object.assign({}, s2), c2 = o2.className || a2.className;
          r2.p = Object.assign({ theme: d && d() }, o2), r2.o = / *go\d+/.test(c2), o2.className = i.apply(r2, l2) + (c2 ? " " + c2 : ""), t2 && (o2.ref = n2);
          let p2 = e2;
          return e2[0] && (p2 = o2.as || e2, delete o2.as), f && p2[0] && f(o2), u(p2, o2);
        }
        return t2 ? t2(a2) : a2;
      };
    };
  }
});

// build/MultiStep.js
var require_MultiStep = __commonJS({
  "build/MultiStep.js"(exports2) {
    "use strict";
    var __createBinding = exports2 && exports2.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports2 && exports2.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports2 && exports2.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    var jsx_runtime_1 = require("react/jsx-runtime");
    var react_1 = __importStar(require("react"));
    var goober_1 = require_goober();
    (0, goober_1.setup)(react_1.default.createElement);
    var Ol = (0, goober_1.styled)("ol")`
  display: flex;
  margin: 0;
  padding-bottom: 2.2rem;
  list-style-type: none;
`;
    var Li = (0, goober_1.styled)("li")`
  display: inline-block;
  text-align: center;
  line-height: 4.8rem;
  padding: 0 0.7rem;
  cursor: pointer;
  min-width: 6rem;

  color: silver;
  border-bottom: 2px solid silver;

 span{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
 }

  &:hover,
  &:before {
    color: #0FA0CE;
  }
  &:after {
    content: "\\00a0\\00a0";
  }   
  &:before {
    position: relative;
    float: left;
    left: 50%;
    width: 1.3em;
    line-height: 1.4em;
    border-radius: 50%;
    bottom: -3.99rem;
  }
`;
    var Todo = (0, goober_1.css)`
  &:before {
    content: "\u039F";
    color: silver;
    background-color: white;
  }
`;
    var Doing = (0, goober_1.css)`
  &:before {
    content: "\u2022";
    color: white;
    background-color: #33C3F0;  
  }
`;
    var Done = (0, goober_1.css)`
  &:before {
    content: "\u2713";
    color: white;
    background-color: #33C3F0;
  }
`;
    var RowDirection = (0, goober_1.css)`
  flex-direction: row;
`;
    var ColumnDirection = (0, goober_1.css)`
  margin-top: 4.8rem;
  flex-direction: column;
`;
    var getStep = (defaultIndex, newIndex, length) => {
      if (newIndex <= length) {
        return newIndex;
      }
      return defaultIndex;
    };
    var getTopNavStyles = (indx, length) => {
      const styles = [];
      for (let i = 0; i < length; i++) {
        if (i < indx) {
          styles.push("done");
        } else if (i === indx) {
          styles.push("doing");
        } else {
          styles.push("todo");
        }
      }
      return styles;
    };
    var getButtonsState = (indx, length, isValidState) => {
      if (indx > 0 && indx < length - 1) {
        return {
          showPrevBtn: true,
          showNextBtn: isValidState ? true : false
        };
      } else if (indx === 0) {
        return {
          showPrevBtn: false,
          showNextBtn: isValidState ? true : false
        };
      } else {
        return {
          showPrevBtn: true,
          showNextBtn: false
        };
      }
    };
    function MultiStep(props) {
      const { children } = props;
      let stepsArray = props.steps;
      if (!stepsArray && !children) {
        throw TypeError("missing children or steps in props");
      }
      const [childIsValid, setChildIsValid] = (0, react_1.useState)(true);
      const setIsChildInValidState = (isValid) => setChildIsValid(isValid);
      let steps = [];
      if (children) {
        let childrenWithProps = react_1.default.Children.map(children, (child, index) => {
          return react_1.default.cloneElement(child, {
            signalIfValid: setIsChildInValidState
          });
        });
        steps = childrenWithProps.map((childComponent) => ({
          title: childComponent.props.title,
          component: childComponent
        }));
      } else {
        steps = stepsArray;
      }
      const numberOfSteps = steps.length;
      const stepCustomStyle = typeof props.stepCustomStyle === "undefined" ? {} : props.stepCustomStyle;
      const showNavButtons = typeof props.showNavigation === "undefined" ? true : props.showNavigation;
      const showTitles = typeof props.showTitles === "undefined" ? true : props.showTitles;
      const directionType = typeof props.direction === "undefined" ? "row" : props.direction;
      const [activeStep, setActiveStep] = (0, react_1.useState)(getStep(0, props.activeStep, numberOfSteps));
      const [stylesState, setStyles] = (0, react_1.useState)(getTopNavStyles(activeStep, numberOfSteps));
      const [buttonsState, setButtons] = (0, react_1.useState)(getButtonsState(activeStep, numberOfSteps, childIsValid));
      (0, react_1.useEffect)(() => {
        setButtons(getButtonsState(activeStep, numberOfSteps, childIsValid));
        console.log(`From parent, child in valid state?: ${childIsValid}, button state: ${buttonsState.showNextBtn}`);
      }, [activeStep, childIsValid]);
      const setStepState = (indx, isValidState) => {
        setStyles(getTopNavStyles(indx, numberOfSteps));
        setActiveStep(indx < numberOfSteps ? indx : activeStep);
        setButtons(getButtonsState(indx, numberOfSteps, isValidState));
      };
      const next = () => setStepState(activeStep + 1);
      const previous = () => setStepState(activeStep > 0 ? activeStep - 1 : activeStep);
      const handleOnClick = (evt) => {
        if (!childIsValid) {
          console.log("Child not in valid state - no transition");
          return;
        }
        if (evt.currentTarget.value === numberOfSteps - 1 && activeStep === numberOfSteps - 1) {
          setStepState(numberOfSteps);
        } else {
          setStepState(evt.currentTarget.value);
        }
      };
      const renderTopNav = () => steps.map((s, i) => {
        var _a;
        return (0, jsx_runtime_1.jsx)(Li, Object.assign({ className: stylesState[i] === "todo" ? Todo : stylesState[i] === "doing" ? Doing : Done, style: Object.assign(Object.assign({}, stepCustomStyle), { transform: directionType == "column" ? "rotate(90deg)" : "rotate(0deg)" }), onClick: handleOnClick, value: i }, { children: showTitles && (0, jsx_runtime_1.jsx)("span", { children: (_a = s.title) !== null && _a !== void 0 ? _a : i + 1 }) }), i);
      });
      const renderButtonsNav = (show, prevButton, nextButton) => show && (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: previous, style: prevButton === null || prevButton === void 0 ? void 0 : prevButton.style, disabled: buttonsState.showPrevBtn ? false : true }, { children: prevButton && prevButton.title ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: prevButton.title }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Prev" }) })), (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: next, style: nextButton === null || nextButton === void 0 ? void 0 : nextButton.style, disabled: buttonsState.showNextBtn ? false : true }, { children: nextButton && nextButton.title ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: nextButton.title }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Next" }) }))] });
      return (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: "flex", flexDirection: directionType === "column" ? "row" : "column" } }, { children: [(0, jsx_runtime_1.jsx)(Ol, Object.assign({ className: directionType === "column" ? ColumnDirection : RowDirection }, { children: renderTopNav() })), steps[activeStep].component, (0, jsx_runtime_1.jsx)("div", { children: renderButtonsNav(showNavButtons, props.prevButton, props.nextButton) })] }));
    }
    exports2.default = MultiStep;
  }
});

// build/index.js
var __importDefault = exports && exports.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MultiStep_1 = __importDefault(require_MultiStep());
exports.default = MultiStep_1.default;
